
    import { Options, Vue } from "vue-class-component";
    import { namespace } from 'vuex-class';
    import CardRh from "@/components/cards/ManzaCard.vue";
    import MatriculaService from "@/service/v1/sigap/MatriculaService";
    import SiteUtils from '@/assets/ts/aplicacao/site';
    import KDataTable from "@/components/datatable/newdatatable.vue";
    import { PerfilConfig } from "@/core/config/PerfisConfig";
    import { Prop } from 'vue-property-decorator';

    const authStore = namespace('auth');

    @Options({
        name: "ReprovacaoDisciplinaIndex",
        components: { CardRh, KDataTable },
    })
    export default class ReprovacaoDisciplinaIndex extends Vue {
        @Prop() readonly disciplina!: any;

        @authStore.Getter
        public perfis!: any;

        public processando = false;
        public reloadDatatable = false;
        public config: any = null;
        public service: any = null;
        public matriculaId: any = null;
        public disciplinaId: any = null;
        public turmaId: any = null;
        public pelotao = '';

        get hasPermissao(): boolean {
            return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE, PerfilConfig.AuxSTE], this.perfis);
        }

        public refreshTable() {
            setTimeout(() => {
                this.reloadDatatable = !this.reloadDatatable;
            }, 300);
        }

        public apertouEnter(e) {
            if (e.key === 'Enter' || e.keyCode === 13) {
                this.refreshTable();
            }
        }

        public limparFiltros() {
            this.pelotao = '';
            this.refreshTable();
        }

        created() {
            this.disciplinaId = this.$route.params.id;
            this.turmaId = this.disciplina.turmaId;
            this.config = { ajax: {}, columns: [], columnDefs: [], order: [] };
            this.service = new MatriculaService();
            this.config.ajax = {
                url: this.service.getApiUrl() + '/Dependencia',
                data: (d) => {
                    const dados = {
                        Skip: d.start,
                        Take: d.length,
                        disciplinaId: this.disciplinaId,
                        turmaId: this.turmaId,
                        pelotao: this.pelotao,
                        search: d.search.value,
                    };
                    return dados;
                }
            };
            this.config.columns = [
                { data: 'usuario.nome', name: 'usuario', orderable: false },
                { data: 'pelotao', name: 'pelotao', class: 'text-center', orderable: false },
                { data: 'mediaFinal', name: 'mediafinal', orderable: false },
            ];
        }
    }
